"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBytes = void 0;
if (typeof Buffer === "undefined") {
    global.Buffer = require("buffer").Buffer;
}
const sjcl = require("react-native-sjcl");
function init() {
    let hexString = jsRandomHex(4096 * 2);
    let stanfordSeed = sjcl.codec.hex.toBits(hexString);
    sjcl.random.addEntropy(stanfordSeed);
}
function addEntropy(entropyBuf) {
    let hexString = entropyBuf.toString("hex");
    let stanfordSeed = sjcl.codec.hex.toBits(hexString);
    sjcl.random.addEntropy(stanfordSeed);
}
function randomBytes(length) {
    let size = length;
    let wordCount = Math.ceil(size * 0.25);
    let randomBytes = sjcl.random.randomWords(wordCount, 10);
    let hexString = sjcl.codec.hex.fromBits(randomBytes);
    hexString = hexString.substr(0, size * 2);
    return new Buffer(hexString, "hex");
}
exports.randomBytes = randomBytes;
function jsRandomHex(length) {
    let result = "";
    for (let i = 0; i < length; i++) {
        result += Math.floor(Math.random() * 16).toString(16);
    }
    return result;
}
init();
